module.exports = __webpack_public_path__ + "img/smash1.2fc1ffe4.png";